import { useRef } from 'react'

import { useTranslations } from 'next-intl'

import { Button } from '@/components/buttons/Button'
import { ExitButton } from '@/components/buttons/ExitButton'
import { StripedContainer } from '@/components/StripedContainer'
import { closeOverlay } from '@/features/overlay/overlaySlice'
import { logOut } from '@/features/user/userSlice'
import { useAppDispatch } from '@/utils/useAppDispatch'
import { useAppSelector } from '@/utils/useAppSelector'

import styles from './Logout.module.scss'

export const Logout: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const t = useTranslations()
  const dispatch = useAppDispatch()
  const email = useAppSelector((state) => state.user.profile?.identifier?.value)

  return (
    <StripedContainer ref={containerRef} containerClass={styles.Container}>
      <ExitButton className={styles.ExitButton} onClick={() => dispatch(closeOverlay)} />
      <div className={styles.Title}>{t('logout_modal_title')}</div>
      <div className={styles.Description}>
        <div className={styles.LogoutModal}>
          <p className={styles.DescriptionText}>{t('logout_modal_desc_standard')}</p>
          <div className={styles.EmailContainer}>
            <p className={styles.LoggedInAs}>{t('logout_modal_email')}</p>
            <p className={styles.Email}>{email}</p>
          </div>
        </div>
      </div>
      <div className={styles.Actions}>
        <Button
          additionalClasses={styles.ConfirmButton}
          type="Primary"
          data-cy="button-confirm"
          onClick={() => {
            dispatch(logOut)
          }}
        >
          {t('logout')}
        </Button>
      </div>
    </StripedContainer>
  )
}
